<template>
    <div class="main_center">
        <div class="content">

            <el-form ref="form" :model="form" label-width="100px" style="    margin-bottom: 16px;">

                <el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="年份：">
                                <el-select v-model="form.year" value-key="value" style="width:100%;" @change="yearsChange">
                                    <el-option v-for="(item, index) in yearsList" :key="index" :label="item"
                                        :value="item"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="8">
                            <el-form-item label="编号：" props="businessCode">
                                <el-input v-model="form.businessCode" clearable placeholder="请输入内容搜索"
                                    @keyup.enter.native="seachBtn"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="moreSearchItem">
                            <el-form-item label="名称：" props="businessName">
                                <el-input v-model="form.businessName" clearable placeholder="请输入内容搜索"
                                    @keyup.enter.native="seachBtn"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="!moreSearchItem">
                            <el-form-item label="">
                                <div>
                                    <el-button plain size="small" type="primary" @click="reflash">重置</el-button>
                                    <el-button size="small" type="primary" @click="seachBtn">搜索</el-button>
                                    <el-button size="mini" type="text" v-if="!moreSearchItem"
                                        @click="moreSearchItem = true">| 展开</el-button>
                                    <el-button size="mini" type="text" v-if="moreSearchItem"
                                        @click="moreSearchItem = false">| 收起</el-button>
                                </div>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-col :span="8" v-if="moreSearchItem">
                        <el-form-item label="见证环节：" props="flowName">
                            <el-input v-model="form.flowName" clearable @keydown.enter.native.stop="getDataList"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-row>
                        <el-col :span="8" v-if="moreSearchItem">
                            <el-form-item label="见证方式：" props="witnessMod">
                                <el-select v-model="form.witnessMod" clearable value-key="value" style="width:100%;"
                                    @change="seachBtn">
                                    <el-option label="全部" value="-1"></el-option>
                                    <el-option v-for="(item, index) in witnessModlist" :key="index" :label="item.name"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="moreSearchItem">
                            <el-form-item label="见证状态：" props="witnessStatus">
                                <el-select v-model="form.witnessStatus" clearable value-key="value" style="width:100%;"
                                    @change="seachBtn">
                                    <el-option label="全部" value="-1"></el-option>
                                    <el-option v-for="(item, index) in witnessStatuslist" :key="index" :label="item.name"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :span="8" v-if="moreSearchItem">
                            <el-form-item label="交易中心：">
                                <el-select v-model="form.tradeId" clearable value-key="value" style="width:100%;"
                                    @change="seachBtn">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="(item, index) in transactionCenterList" :key="index"
                                        :label="item.orgName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="moreSearchItem">
                            <el-form-item label="项目关注度：" prop="importantPrj">
                                <!--单选按钮-->
                                <el-radio :label=-1 v-model="form.importantPrj">全部项目</el-radio>
                                <el-radio :label=1 v-model="form.importantPrj">重点关注项目</el-radio>
                                <el-radio :label=0 v-model="form.importantPrj">非重点关注项目</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="moreSearchItem">
                            <el-form-item label="">
                                <div>
                                    <el-button plain size="small" type="primary" @click="reflash">重置</el-button>
                                    <el-button size="small" type="primary" @click="seachBtn">搜索</el-button>
                                    <el-button size="mini" type="text" v-if="!moreSearchItem"
                                        @click="moreSearchItem = true">| 展开</el-button>
                                    <el-button size="mini" type="text" v-if="moreSearchItem"
                                        @click="moreSearchItem = false">| 收起</el-button>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-row>
            </el-form>

            <space :left="-16" :right="-16" :bottom="16" />

            <el-table :data="tableData" v-loading="dataListLoading" ref="expertExtractTable" :height="tableMaxHeight" stripe
                border>
                <el-table-column label="序号" type="index" :index="indexMethod" width="50" align="center"
                    :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="操作" align="left" width="150px" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" title="见证" @click="router(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
  
                <el-table-column label="标段名称" prop='businessName' align="left" width='400'
                    :show-overflow-tooltip='true'></el-table-column>

                <el-table-column label="授权状态" prop='applyState' align="left" width='120' :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <applyStatus :status="scope.row.witnessStatus" mapName="tag" />
                    </template>
                </el-table-column>
                <!-- 申请人 申请查看类型 申请时间 -->
                <el-table-column label="申请人" prop='applyUserName' align="left" width='120'
                    :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="申请查看类型" prop='applyType' align="left" width='120'
                    :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <tags :status="scope.row.applyType" mapName="tag" />
                    </template>
                </el-table-column>
                <el-table-column label="申请时间" prop='applyTime' align="left" width='200'
                    :show-overflow-tooltip='true'></el-table-column>
                    <!-- 授权状态 待授权人/授权人 授权人短信回复时间 授权到期时间 项目所属交易中心 -->
                <el-table-column label="授权状态" prop='applyState' align="left" width='120'
                    :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <applyStatus :status="scope.row.applyState" mapName="tag" />
                    </template>
                </el-table-column>
                <el-table-column label="待授权人/授权人" prop='authUserName' align="left" width='120'
                    :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="授权人短信回复时间" prop='authReplyTime' align="left" width='200'
                    :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="授权到期时间" prop='authEndTime' align="left" width='200'
                    :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="项目所属交易中心" prop='tradeName' align="left" width='200'
                    :show-overflow-tooltip='true'></el-table-column>

            </el-table>
            <pagination class="limit" :page-sizes="[10, 20, 50, 100]" :total="total" :page.sync="pageIndex"
                :limit.sync="pageSize" @pagination="paginationChange">
            </pagination>
        </div>
    </div>
</template>

<script>
import space from '../../common/components/space.vue';
import Pagination from '@/components/Pagination'
import { nearSixYearsList } from '@/utils/index';
import tags from './components/tags.vue';
import applyStatus from './components/applyStatus.vue';

export default {
    name: "expertExtractList",
    components: {
        space,
        Pagination,
        tags,
        applyStatus
    },
    data() {
        return {
            form: {
                year: new Date().getFullYear(),
                businessCode: "",
                businessName: "",
                witnessMod: "-1",
                witnessStatus: "-1",
                importantPrj: -1,
                flowName: '',
                tradeId: '', // 交易中心ID
            },
            businessType: 'GC',
            moreSearchItem: false,
            yearsList: [],
            tableData: [],
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            dataListLoading: false,
            tableMaxHeight: document.documentElement.clientHeight - 275,
        }
    },
    methods: {
        ifmove() {
            // let hasBtnPermisson = this.hasBtnPermission('btn_jz_buswitness_'+this.businessType+'del');
            const hasBtnPermisson = false
            let tableMaxHeight = document.documentElement.clientHeight - 275 + (hasBtnPermisson ? 0 : 41);
            this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
            this.$nextTick(() => {
                this.tableMaxHeight = tableMaxHeight
            })
        },
        seachBtn() {
            this.pageIndex = 1;
            this.getList();
        },
        reflash() {
            this.form = {
                year: new Date().getFullYear(),
                businessCode: "",
                businessName: "",
                witnessMod: "-1",
                witnessStatus: "-1",
                importantPrj: -1,
                flowName: '',
                tradeId: '', // 交易中心ID
            };
            this.pageIndex = 1;
            this.getList();
        },
        yearsChange(val) {
            this.yearsList = nearSixYearsList(val)
            this.getList();
        },
        getList() {
            this.$http.post(`/businessFlowWitness/expertList`, {
                page: this.page,
                rows: this.pageSize,
                filter: {
                    auditYear: this.form.year,
                    witnessMod: this.form.witnessMod == "-1" ? "" : this.form.witnessMod,
                    importantPrj: this.form.importantPrj == -1 ? "" : this.form.importantPrj,
                    witnessStatus: '',
                    businessName: this.form.businessName,
                    businessCode: this.form.businessCode,
                    businessType: this.businessType,
                    flowName: this.form.flowName,
                    tradeId: this.form.tradeId
                },
            }).then(res => {
                this.tableData = res.data.rows;
                this.total = res.data.total;
            })
        },
        paginationChange({page, limit}) {
            this.pageIndex = page;
            this.pageSize = limit;
            this.getList();
        },
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        router(item) {
            this.$router.push({
                name: 'busWitness_detail',
                query: {
                    businessType: this.businessType,
                    id: item.id,
                    purchaserMode: item.purchaserMode || '',
                    evalcommitteeBuildId: item.evalcommitteeBuildId,
                    tenderCode: item.businessCode,
                }
            })
        },
        extractRouter(row) {
            window.open('https://183.95.190.180:82/TPFrame/customframe4bid/login_TP');
        },
        routerSign(row) {
            this.$router.push({
                name: 'expertExtract_detail',
                query: {
                    businessType: row.businessType,
                }
            })
        }
    },
    activated() {

        this.getList()

    },
    mounted() {
        // this.getList();
        this.yearsList = nearSixYearsList(this.form.year);
        this.ifmove()
        let resizeTag = true;
        let that = this;
        window.onresize = () => {
            if (resizeTag) { //防抖动
                that.ifmove();
                resizeTag = false
                setTimeout(() => {
                    resizeTag = true
                }, 1000)
            }
        }
    },
}

</script>
